import { useState, useEffect } from "react";

export const useScrolled = (threshold = 10) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const toggleScroll = () => setScrolled(window.scrollY > threshold);

    window.addEventListener("scroll", toggleScroll, { passive: true });
    return () => window.removeEventListener("scroll", toggleScroll);
  }, [threshold]);

  return scrolled;
};
